module.exports = __webpack_public_path__ + "assets/img/btn-view-pedigree-chart-3e1ef6cd.png";